import {absCenterX} from '@xpertdox_js/xdstyle';
import {colors} from '../../defaultSettings';

export default {
  container: {
    ...absCenterX,
    top: '65px',
    background: colors.bg.panel,
    border: '1px solid ' + colors.panelBorder,
    borderRadius: '4px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.16)',
    width: '320px',
    zIndex: 22,
    fontSize: '1.2rem',
    padding: '8px'
  },
  title: {
    fontSize: '1.6rem',
    margin: '0 0 8px',
  },
  tip: {
    margin: 0,
  }
}
